'use client';
import React from 'react';

import { Typography } from '@mui/material';

export default function ContentHeading({ text, simple }) {
  const [h1, h2]: string[] = React.useMemo((): string[] => {
    if (!text) {
      return [];
    }

    // if (text.includes('#')) {
    //   const parts = text.split('#');
    //   return (
    //     <>
    //       <span>{parts[0]}</span>
    //       <br />
    //       <span>{parts[1]}</span>
    //     </>
    //   );
    // }
    // return text;

    if (text.includes('#')) {
      const regexp = /#\d+\s*\(.+\)(?:\s*#\d+\s*\(.+\))*\s*$/;
      const matches = text.match(regexp);
      if (Array.isArray(matches) && matches.length > 0 && matches[0]?.length > 10) {
        const heading1 = text.replace(regexp, '');
        const heading2 = matches ? matches[0] : '';

        return [heading1, heading2];
      }
    }

    if (text.includes('(')) {
      const regexp = /\(\s*([^)]*?)\s*\)\s*$/;
      const matches = text.match(regexp);
      if (Array.isArray(matches) && matches.length > 0 && matches[0]?.length > 7) {
        const heading1 = text.replace(regexp, '');
        const heading2 = matches ? matches[0] : '';

        return [heading1, heading2];
      }
    }

    return [text];
  }, [text]);

  if (!h2) {
    return (
      <Typography
        variant="h1"
        component="h1"
        sx={{
          marginBottom: simple ? 'auto' : '20px',
          padding: simple ? '1.25rem 0 0 0' : '1.25rem 0 1.25rem 0',
          fontSize: '3rem',
        }}
      >
        {h1}
      </Typography>
    );
  }

  return (
    <div
      style={{
        padding: simple ? '1.25rem 0 0 0' : '1.25rem 0 1.25rem 0',
      }}
    >
      <Typography
        variant="h1"
        component="h1"
        sx={{
          fontSize: '3rem',
        }}
      >
        {h1}
      </Typography>
      <Typography
        variant="h2"
        component="h2"
        sx={{
          marginBottom: simple ? 'auto' : '20px',
          fontSize: '2rem',
        }}
      >
        {h2}
      </Typography>
    </div>
  );
}
